import { ThemeProps } from 'styled-components/macro';
import { Theme } from '@material-ui/core';
import { createGlobalStyle } from 'styled-components';
import 'react-perfect-scrollbar/dist/css/styles.css';
// import '@splidejs/splide/dist/css/splide.min.css';

type GlobalStyleProps = {
  theme: ThemeProps<Theme> & { palette: any };
};

export default createGlobalStyle<GlobalStyleProps>`
  *{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }
  html,
  body,
  #root {
    height: 100%;
  }
  html{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body {
    font-family: 'Be Vietnam', sans-serif;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5;
    background: ${props => props.theme.palette.background.default};
  }
  body, input, button {
    font: 15px 'Be Vietnam', sans-serif;
  }
  button {
    cursor: pointer;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .swal2-container {
    z-index: 9999;
  }
  .swal2-styled, .swal2-confirm, .swal2-deny, .swal2-cancel {
    margin: 4px;
  }

  .button-danger, .button-danger:hover{
    background-color: rgb(255, 4, 4);
    color: #FFF;
  }

  .makeStyles-content-2{
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }

  .MuiInputLabel-outlined{
    color: #999;
  }

  .button-danger, .button-danger:hover{
    background-color: #d32f2f;
    color: #FFF;
  }

  .button-warning, .button-warning:hover{
    background-color: orange;
    color: #FFF;
  }

  .button-success, .button-success:hover{
    background-color: #4caf50;
    color: #FFF;
  }

  .button-primary, .button-primary:hover{
    background-color: #0068e9;
    color: #FFF;
  }

  .infinite-scroll-component__outerdiv {
     width: 100%;
}
`;
